var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDamIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 52 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "damIcon",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,18.91 L3,1 C3,0.44771525 3.44771525,0 4,0 L50,0 C50.5522847,0 51,0.44771525 51,1 L51,44 C51,44.5522847 50.5522847,45 50,45 L4,45 C3.44771525,45 3,44.5522847 3,44 L3,27.59",
    id: "Path",
    stroke: "#004A80",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#004A80",
    fillRule: "nonzero",
    cx: 3,
    cy: 26.59,
    r: 3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.35,13.0067143 C21.784613,12.935076 23.1884781,13.4390276 24.25,14.4067143 C25.3002195,15.5186943 25.8337974,17.021424 25.72,18.5467143 L25.72,26.7767143 C25.8292757,28.3114806 25.2674533,29.818186 24.18,30.9067143 C23.082442,31.8828533 21.6473714,32.3923034 20.18,32.3267143 L15,32.3267143 L15,13.0067143 L20.35,13.0067143 Z M21.76,28.4867143 C22.1433419,27.8560849 22.3247798,27.1233548 22.28,26.3867143 L22.28,19.1367143 C22.3280339,18.354634 22.1547471,17.5748433 21.78,16.8867143 C21.4507353,16.3730891 20.8688954,16.0783413 20.26,16.1167143 L18.41,16.1167143 L18.41,29.2467143 L20.25,29.2467143 C20.8534124,29.2835129 21.430067,28.9932761 21.76,28.4867143 L21.76,28.4867143 Z",
    id: "Shape",
    fill: "#0174C3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.37,28.55 L30.62,32.32 L27,32.32 L32,13 L35.32,13 L40.25,32.32 L36.67,32.32 L35.88,28.57 L31.37,28.55 Z M33.62,17.63 L32.02,25.47 L35.26,25.47 L33.62,17.63 Z",
    id: "Shape",
    fill: "#0174C3",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDamIcon);
export default __webpack_public_path__ + "static/media/damIcon.e00777b35bc0f9fe943552abc210dd6c.svg";
export { ForwardRef as ReactComponent };